import React, { Children, FC, ReactNode } from 'react';
import { ColumnWrapper, Root, SectionTitle } from './PanelSection.styled';
import { useLimitedChildren } from './useLimitedChildren';

export interface PanelSectionProps {
  /** Name of the section that if present is displayed on the top. */
  name?: ReactNode;
  /** Option to automatically hide part of the records */
  showGradually?: boolean;
  /** Number of records to show per column. Defaults to `4` */
  recordsPerColumn?: number;
  /** Column width that will be applied to pc version. Mostly used for preventing the column jumping around when some of the records are really long. */
  columnWidth?: 'auto' | number;
  /** Called when `Show more` is clicked **/
  onShowMore?: () => void;
}

export const PanelSection: FC<React.PropsWithChildren<PanelSectionProps>> = ({
  showGradually,
  columnWidth = 'auto',
  name,
  onShowMore,
  children,
  recordsPerColumn = 4,
}) => {
  const [visibleChildren, recordCount, link] = useLimitedChildren({ children: Children.toArray(children), recordsPerColumn, showGradually, onShowMore });

  return (
    <Root recordCount={recordCount} recordsPerColumn={recordsPerColumn}>
      {name && <SectionTitle>{name}</SectionTitle>}
      <ColumnWrapper columnWidth={columnWidth} recordCount={recordCount} recordsPerColumn={recordsPerColumn}>
        {visibleChildren}
        {link}
      </ColumnWrapper>
    </Root>
  );
};
